import * as React from 'react';

import './NavigationHeaderSideNav.scss';

export interface NavigationHeaderSideNavProps {
}

export default class NavigationHeaderSideNavPartial extends React.Component<NavigationHeaderSideNavProps, any> {
  public render() {
    return (
      <div className="navigation-header-side-nav-partial border-bottom pt-4 pb-4 text-center">
        Sidenav Header
      </div>
    );
  }
}
